<div class="px-plus">
  <common-ui-components-title-summary
    [title]="'خرید حضوری'"
    [showButton]="true"
    [buttonIconReversed]="true"
    [buttonTitle]="'همه'"
    [buttonIcon]="'arrow-2-left'"
    [navigationLink]="'stores/all-stores'"
    [navigationParams]="{
      sort: 'priority',
      types: '0',
    }"
  ></common-ui-components-title-summary>
</div>

<common-ui-components-horizontal-scroll [classes]="'mb-pony mt-low gap-low pr-plus'">
  <ngx-chip
    [id]="'all-chip'"
    [size]="'MEDIUM'"
    [leadingIcon]="'more'"
    [label]="'همه دسته‌بندی‌ها'"
    [pressed]="!selectedCategory()"
    (click)="changeCategory()"
  >
  </ngx-chip>
  @for (category of categories; track $index) {
    <ngx-chip
      [id]="category + '-chip'"
      [size]="'MEDIUM'"
      [label]="StoreCategoryTitleMapper[category.title]"
      [leadingIcon]="StoreCategoryToIconMapper[category.title]"
      [pressed]="category.id === selectedCategory()?.id"
      (click)="changeCategory(category)"
    >
    </ngx-chip>
  }
</common-ui-components-horizontal-scroll>
<common-ui-components-horizontal-scroll [classes]="'pr-plus'">
  @for (store of stores(); track $index) {
    <div class="d-flex flex-column gap-pony">
      <daily-stores-store-preview
        (click)="goToStorePage(store[0]!.trackingCode)"
        [store]="store[0]"
        [mode]="'with-details'"
      ></daily-stores-store-preview>
      @if (store[1]) {
        <daily-stores-store-preview
          (click)="goToStorePage(store[1]!.trackingCode)"
          [store]="store[1]"
          [mode]="'with-details'"
        ></daily-stores-store-preview>
      }
    </div>
  } @empty {
    <div class="d-flex flex-column gap-pony">
      <daily-stores-store-preview [mode]="'with-details'"></daily-stores-store-preview>
      <daily-stores-store-preview [mode]="'with-details'"></daily-stores-store-preview>
    </div>
    <div class="d-flex flex-column gap-pony">
      <daily-stores-store-preview [mode]="'with-details'"></daily-stores-store-preview>
      <daily-stores-store-preview [mode]="'with-details'"></daily-stores-store-preview>
    </div>
    <div class="d-flex flex-column gap-pony">
      <daily-stores-store-preview [mode]="'with-details'"></daily-stores-store-preview>
      <daily-stores-store-preview [mode]="'with-details'"></daily-stores-store-preview>
    </div>
  }
</common-ui-components-horizontal-scroll>
